// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const TrashCan = createIcon(
  <path
    clipRule="evenodd"
    d="M8.40045 2.99951C7.90339 2.99951 7.50045 3.40246 7.50045 3.89951C7.50045 4.39657 7.90339 4.79951 8.40045 4.79951H15.601C16.0981 4.79951 16.501 4.39657 16.501 3.89951C16.501 3.40246 16.0981 2.99951 15.601 2.99951H8.40045ZM4.7998 7.04994C4.7998 6.55288 5.20275 6.14994 5.6998 6.14994H18.3008C18.7979 6.14994 19.2008 6.55288 19.2008 7.04994C19.2008 7.547 18.7979 7.94994 18.3008 7.94994H17.8509V19.901C17.8509 20.5085 17.3585 21.001 16.7509 21.001H7.25013C6.64261 21.001 6.15013 20.5085 6.15013 19.901V7.94994H5.6998C5.20275 7.94994 4.7998 7.547 4.7998 7.04994ZM7.95013 7.94994H16.0509V19.201H7.95013V7.94994Z"
    fillRule="evenodd"
  />,
);
